import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FarmEnvironmentService {

  constructor(private httpClient: HttpClient, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;
  addFarmUser(farmEnv:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/FarmhouseEnvironment/AddFarmhouseEnvironment`,farmEnv).pipe(
      //catchError(this.error)
    );;
  }
  getFarmEnvironmentList(userId:number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/FarmhouseEnvironment/GetFarmhouseEnvironmentLists?userId=${userId}`).pipe(
      //catchError(this.error)
    );;
  }
  getFarmHouseReadingData(filterParams:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/FarmhouseEnvironment/GetSensorReadingDataForReport`,filterParams).pipe(
      //catchError(this.error)
    );;
  }
  getDashboardFarmHouseReadingData(filterParams:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/FarmhouseEnvironment/GetDashboardSensorReadingDataForReport`,filterParams).pipe(
      //catchError(this.error)
    );;
  }
  getDashboardFarmHouseForcastReadingData(filterParams:any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/FarmhouseEnvironment/DashboardDataForecastingReport`,filterParams).pipe(
      //catchError(this.error)
    );;
  }
  getdashboardFarmList(userId: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/FarmhouseEnvironment/GetDashboardFarmList?userId=${userId}`).pipe(
      
    );
  }
  getdashboardFarmHouseList(farmId: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/FarmhouseEnvironment/GetDashboardFarmHouseList?farmId=${farmId}`).pipe(
      
    );
  }
  getdashboardFarmHousePartitionList(farmhouseId: number): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/FarmhouseEnvironment/GetDashboardFarmHousePartitionList?farmhouseId=${farmhouseId}`).pipe(
     
    );
  }
}
